import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

export const sendPrivacyPolicySelectedEvent = (
  evt: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
) => {
  sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_action: 'Newsletter click',
    event_category: 'Footer',
    event_label: 'privacy policy',
  });
};
